import { styled } from '@mui/material/styles';
import VpButton from '../VpButton';

const svgStyles = {
  height: '20px',
  width: '20px',
  minWidth: '20px',
  minHeight: '20px'
};

export const StyledSocialButton = styled(VpButton)(({ theme }) => ({
  borderRadius: '50%',
  padding: '10px',
  boxSizing: 'content-box',
  color: theme.palette.vpColors.white,
  ...svgStyles,
  svg: {
    color: theme.palette.vpColors.white,
    padding: '0px',
    ...svgStyles
  }
}));



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpSocialMediaShareButtons/styles.js